<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "updateInfo",
}
</script>

<style>
</style>
